<template>


  <div class="max-w-full mt-40">

    <create-room-form @created="roomCreated"></create-room-form>
  </div>


</template>

<script>

import AppLayout from "@/Layouts/AppLayout";
import CreateRoomForm from "@/Pages/PlanningPoker/CreateRoomForm";
import {Inertia} from "@inertiajs/inertia";


export default {
  props: [],
  components: {
    CreateRoomForm,
    AppLayout,
  },
  setup() {
    const roomCreated = (id) => {
      Inertia.visit(
          route("planning-rooms.accessRoom", {
            id: id,
          })
      );
    }
    return {
      roomCreated
    }
  },
};
</script>
